import BMF from 'browser-md5-file'

const useAliyunOssUpload = () => {
  const getMd5 = (file: any, callBack?: any) =>
    new Promise((resolve) => {
      const bmf = new BMF()
      bmf.md5(
        file,
        (err: any, md5: any) => {
          resolve(md5)
          if (err) console.log('getMd5-err:', err)
        },
        (progress: any) => callBack && callBack(progress)
      )
    })

  const uploadAliyunOss = (params: any) => {
    const { file, client, updateCheckpoint, cb, filename } = params
    let { tempCheckpoint } = params

    return new Promise(async (resolve, reject) => {
      let retryTimes = 0
      const MAX_RETRY_TIMES = 2

      async function multipartUpload() {
        try {
          // object-key可以自定义为文件名（例如file.txt）或目录（例如abc/test/file.txt）的形式，实现将文件上传至当前Bucket或Bucket下的指定目录。
          return await client.multipartUpload(filename, file, {
            progress: (p: any, checkpoint: any) => {
              tempCheckpoint = checkpoint
              if (updateCheckpoint) updateCheckpoint(checkpoint)
              if (cb) cb(p)
            },
            checkpoint: tempCheckpoint
          })
        } catch (e) {
          if (retryTimes <= MAX_RETRY_TIMES) {
            retryTimes++
            const retData = await multipartUpload()
            if (retData && retData.name) resolve(retData)
          } else {
            reject(e)
          }
        }
      }

      // 开始分片上传。
      const res = await multipartUpload()
      if (res && res.name) resolve(res)
    })
  }

  return { uploadAliyunOss, getMd5 }
}

export { useAliyunOssUpload }
